/** Matches Application underwrite checklist panel width (`.checklistRight`). */
export const RESIDENT_INSTRUCTIONS_PANEL_WIDTH_PX = 420

/**
 * When the instructions panel is open and the viewport is narrower than this,
 * the residents table uses horizontal scroll instead of crushing columns.
 */
export const RESIDENT_INSTRUCTIONS_TABLE_SCROLL_BELOW_PX = 1250
